export var TemplateType;
(function (TemplateType) {
    TemplateType["certificate"] = "certificate";
    TemplateType["badge"] = "badge";
})(TemplateType || (TemplateType = {}));
export var TemplatePageOrientations;
(function (TemplatePageOrientations) {
    TemplatePageOrientations["portrait"] = "vertical";
    TemplatePageOrientations["landscape"] = "horizontal";
})(TemplatePageOrientations || (TemplatePageOrientations = {}));
export var RenderTemplateContentTypes;
(function (RenderTemplateContentTypes) {
    RenderTemplateContentTypes["DEFINITION"] = "application/vnd.pok.definition+json";
    RenderTemplateContentTypes["ID"] = "application/vnd.pok.template-id+json";
})(RenderTemplateContentTypes || (RenderTemplateContentTypes = {}));
export var RenderTemplateAccepts;
(function (RenderTemplateAccepts) {
    RenderTemplateAccepts["IMAGE_DATA_URI"] = "application/vnd.pok.image-data-uri+json";
    RenderTemplateAccepts["TEMPLATE"] = "application/vnd.pok.template+json";
    RenderTemplateAccepts["IMAGE_URL"] = "application/vnd.pok.image-url+json";
})(RenderTemplateAccepts || (RenderTemplateAccepts = {}));
export const localeFor = (definition) => definition.params.find((param) => param.name === 'locale')?.value || 'en';
export function isTextItem(item) {
    return item.type === 'text';
}
export const componentTypes = {
    image: 'image',
    text: 'text',
    qr: 'qrcode',
};
export const componentSubTypes = {
    signature: 'signature',
};
export const ListTemplatesQsp = {
    owner: 'owner',
    type: 'type',
    locale: 'locale',
    tagId: 'tagId',
    orderBy: 'orderBy',
    orderAscending: 'orderAscending',
};
//# sourceMappingURL=schema.js.map